import { Typography } from '@navi/web-ui/lib/primitives';
import AlertCircleIcon from '@cp/src/assets/icons/AlertCircleIcon';
import Modal from '@cp/src/components/Modal/Modal';
import { noop } from '@tanstack/react-table';
import longhornQRCode from '@cp/src/assets/images/longhorn_agent_download_qr.png';
import { useEffect } from 'react';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

const BlockedLonghorn = () => {
  const userData = useSelector((state: RootState) => state.common.userData);
  const cosmosVersionData = useSelector((state: RootState) => state.common.cosmosVersionData);
  const isCosmosUpdateRequired = useSelector(
    (state: RootState) => state.common.isCosmosUpdateRequired
  );
  const userAppVersion = useSelector((state: RootState) => state.common.userAppVersion);

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.COSMOS_UPDATE_REQUIRED_MODAL_SHOWN, {
      agentRefId: userData?.referenceId,
      agentName: userData?.name,
      agentEmail: userData?.email,
      currentAppVersion: cosmosVersionData?.appVersion,
      isUpdateRequired: isCosmosUpdateRequired,
      appType: cosmosVersionData?.appType,
      userAppVersion: userAppVersion,
      timestamp: new Date().toISOString()
    });
  }, []);

  return (
    <Modal visible={true} onClose={noop} showCloseIcon={false} closeOnOutsideClick={false}>
      <div className="flex flex-col">
        <div className="flex items-center gap-2 mb-4 justify-center">
          <AlertCircleIcon width={24} height={24} />
          <Typography variant="h3" color="var(--navi-color-gray-c1)">
            App Update Required
          </Typography>
        </div>
        <div className="bg-red-50 p-4 rounded-lg flex items-center gap-4">
          <div className="flex flex-col gap-2">
            <Typography variant="p3" color="var(--navi-color-gray-c1)" className="font-semibold">
              Your Cosmos app needs an update
            </Typography>
            <Typography variant="p4" color="var(--navi-color-gray-c2)">
              To continue accessing Longhorn and all its features,
              <br /> please update to the latest version of COSMOS app.
            </Typography>
            <Typography variant="p4" color="var(--navi-color-gray-c2)">
              <span className="font-medium">How to update:</span>
              <br />
              • Scan the QR code with your phone
              <br />• or visit our{' '}
              <a
                href="https://longhorn.navi.com/calling-agent-download"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-600 hover:text-blue-800"
              >
                download page
              </a>
            </Typography>
          </div>
          <img
            src={longhornQRCode}
            alt="QR code for Longhorn app download"
            className="w-28 h-28 flex-shrink-0 bg-white"
          />
        </div>
      </div>
    </Modal>
  );
};

export default BlockedLonghorn;
